export const VIDEO_UPLOADING = 'uploading';

export const VIDEO_PROCESSING = 'processing';

export const VIDEO_READY = 'ready';
